const boardActionTypes = {
    SHUFFLE_BOARD: 'SHUFFLE_BOARD',
    CHECK_BLOCK: 'CHECK_BLOCK',
    TOGGLE_EXTREME: 'TOGGLE_EXTREME'
}

export default boardActionTypes;